

    <div class="connection">

      <span class="name">{{ vertex.name }}
        <span *ngIf="isEdgeNamed">
          → {{edgeName}}
        </span>
      </span>

      <div class="actions">
        <a href="javascript:;" title="Move Up" (click)="moveUp()">▲</a>
        <a href="javascript:;" title="Move Down" (click)="moveDown()">▼</a>
      </div>

      <div style="width: 1rem">&nbsp;</div>

      <button type="button" (click)="remove()" class="close" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>

    </div>

  


// WEBPACK FOOTER //
// ./src/library/designer/vertex/workflow-designer-vertex-connection.component.ts.WorkflowDesignerVertexConnectionComponent.html